var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c("group-page-header", { attrs: { title: "Group Events" } }, [
        _vm.viewer_state.is_admin
          ? _c(
              "span",
              {
                attrs: { slot: "additionalButtons" },
                slot: "additionalButtons",
              },
              [
                _c("vue-folder-button", {
                  attrs: {
                    tabindex: "0",
                    role: "button",
                    "icon-class": "fa-plus",
                    text: "Create Event",
                    "aria-label": "Create Event",
                  },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.createEvent.apply(null, arguments)
                    },
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("group-events-page", {
        staticClass: "margin-10-top",
        attrs: { group: _vm.group },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }